import { Card, CardContent } from '../ui/card';
import { DollarSign, CreditCard, TrendingUp, BarChart3 } from 'lucide-react';

const MerchantStats = ({ analytics }) => {
  const stats = [
    {
      label: 'Total Revenue',
      value: `$${analytics?.total_revenue?.toFixed(2) || '0.00'}`,
      icon: DollarSign,
      color: 'emerald'
    },
    {
      label: 'Transactions',
      value: analytics?.total_transactions || 0,
      icon: CreditCard,
      color: 'blue'
    },
    {
      label: 'Net Revenue',
      value: `$${analytics?.net_revenue?.toFixed(2) || '0.00'}`,
      icon: TrendingUp,
      color: 'purple'
    },
    {
      label: 'Avg. Transaction',
      value: `$${analytics?.average_transaction?.toFixed(2) || '0.00'}`,
      icon: BarChart3,
      color: 'orange'
    }
  ];

  const colorClasses = {
    emerald: 'bg-emerald-500/10 text-emerald-600',
    blue: 'bg-blue-500/10 text-blue-600',
    purple: 'bg-purple-500/10 text-purple-600',
    orange: 'bg-orange-500/10 text-orange-600'
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {stats.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <Card key={stat.label} data-testid={`stat-card-${index}`}>
            <CardContent className="pt-6">
              <div className="flex items-center gap-3">
                <div className={`p-2 rounded-lg ${colorClasses[stat.color]}`}>
                  <Icon className="w-5 h-5" />
                </div>
                <div>
                  <p className="text-sm text-muted-foreground">{stat.label}</p>
                  <p className="text-2xl font-bold">{stat.value}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default MerchantStats;
